import Papa from 'papaparse';

export const PRODUCT_CSV_FIELDS = [
  { key: 'name', label: 'Name', type: 'string' },
  { key: 'sku', label: 'SKU', type: 'string' },
  { key: 'productType', label: 'Product Type', type: 'string' },
  { key: 'categoryId', label: 'Category ID', type: 'number' },
  { key: 'supplierId', label: 'Supplier ID', type: 'number' },
  { key: 'brandId', label: 'Brand ID', type: 'number' },
  { key: 'unitOfMeasure', label: 'Unit Of Measure', type: 'string' },
  { key: 'salesPrice', label: 'Sales Price', type: 'number' },
  { key: 'cost', label: 'Cost', type: 'number' },
  { key: 'quantityOnHand', label: 'Quantity On Hand', type: 'number' },
  { key: 'canBeSold', label: 'Can Be Sold', type: 'boolean' },
  { key: 'trackInventory', label: 'Track Inventory', type: 'boolean' },
  { key: 'isFavorite', label: 'Is Favorite', type: 'boolean' },
  { key: 'description', label: 'Description', type: 'string' },
  { key: 'reference', label: 'Reference', type: 'string' },
  { key: 'barcode', label: 'Barcode', type: 'string' },
  { key: 'internalNotes', label: 'Internal Notes', type: 'string' },
  { key: 'responsible', label: 'Responsible', type: 'string' },
  { key: 'weight', label: 'Weight', type: 'number' },
  { key: 'volume', label: 'Volume', type: 'number' },
  { key: 'customerLeadTime', label: 'Customer Lead Time', type: 'number' },
  { key: 'descriptionReceipts', label: 'Description Receipts', type: 'string' },
  { key: 'descriptionDelivery', label: 'Description Delivery', type: 'string' },
];

const labelToKey = PRODUCT_CSV_FIELDS.reduce((acc, field) => {
  acc[field.label] = field.key;
  return acc;
}, {});

const NUMBER_FIELDS = new Set(
  PRODUCT_CSV_FIELDS.filter((f) => f.type === 'number').map((f) => f.key)
);

const BOOLEAN_FIELDS = new Set(
  PRODUCT_CSV_FIELDS.filter((f) => f.type === 'boolean').map((f) => f.key)
);

function formatValue(key, value) {
  if (value === null || value === undefined) return '';
  if (BOOLEAN_FIELDS.has(key)) return value ? 'Yes' : 'No';
  return value;
}

function parseValue(key, value) {
  if (value === '' || value === null || value === undefined) return null;
  if (NUMBER_FIELDS.has(key)) {
    const num = Number(value);
    return isNaN(num) ? value : num;
  }
  if (BOOLEAN_FIELDS.has(key)) {
    const lower = String(value).toLowerCase().trim();
    if (lower === 'yes' || lower === 'true') return true;
    if (lower === 'no' || lower === 'false') return false;
    return value;
  }
  return value;
}

export function exportProductsToCsv(products, options = {}) {
  const exportFields = PRODUCT_CSV_FIELDS;
  const headers = exportFields.map((f) => f.label);

  const rows = products.map((product) =>
    exportFields.map((field) => formatValue(field.key, product[field.key]))
  );

  const csv = Papa.unparse({ fields: headers, rows });
  const bom = '\uFEFF';
  const csvWithBom = bom + csv;

  const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const date = new Date().toISOString().slice(0, 10);
  const filename = options.filename || `products_export_${date}.csv`;
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return csvWithBom;
}

export function parseProductsCsv(file) {
  return new Promise((resolve) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const valid = [];
        const errors = [];

        results.data.forEach((row, index) => {
          const rowNum = index + 2;
          const product = {};

          for (const [label, value] of Object.entries(row)) {
            const key = labelToKey[label];
            if (!key) continue;
            if (key === 'id' || key === 'organization') continue;
            product[key] = parseValue(key, value);
          }

          if (!product.name || String(product.name).trim() === '') {
            errors.push({ row: rowNum, message: 'Name is required' });
            return;
          }

          valid.push(product);
        });

        resolve({ valid, errors });
      },
      error: (err) => {
        resolve({ valid: [], errors: [{ row: 0, message: err.message }] });
      },
    });
  });
}

export function downloadProductTemplate() {
  const headers = PRODUCT_CSV_FIELDS.map((f) => f.label);
  const exampleRow = [
    'Sample Product',
    'SKU-001',
    'goods',
    '1',
    '',
    '',
    'unit',
    '19.99',
    '10.00',
    '50',
    'Yes',
    'Yes',
    'No',
    'A sample product',
    'REF-001',
    '123456789',
    '',
    '',
    '0',
    '0',
    '0',
    '',
    '',
  ];

  const csv = Papa.unparse({ fields: headers, rows: [exampleRow] });
  const bom = '\uFEFF';
  const csvWithBom = bom + csv;

  const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'product_import_template.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
